import React, { Component } from 'react';

import '../statics/css/sidemenu.css';

import Logo from '../statics/images/logo_default_white.png'
import iconTreino from '../statics/images/dumbell.svg'
import { Image } from 'react-bootstrap';
import { Glyphicon } from 'react-bootstrap';

import If from "../utils/If"

import IconMenuSvg from '../utils/icons-menus-svg'

class SideMenu extends Component {

  constructor(props) {
    super(props);

    this.state = {
      users: [],
      activeMenu: 'home',
      sub_activeMenu: '',
    };

    this.actionMenu = this.actionMenu.bind(this);

  }

  componentWillMount() {
    //this.props.history.push('/login');
  }

  handleSubmit(user) {

    //console.log(user);
  }

  actionMenu(event, subMenus) {

    console.log("Event: " + event);
    this.state.activeMenu = event;
    this.setState({
      actionMenu: event,
    })
    if (!subMenus) {
      this.props.onHandleMenu(event);
    }

  }

  handleActionMenu(event) {
    this.setState({
      sub_activeMenu: event,
    })
    this.props.onHandleMenu(event);
  }

  render() {

    return (
      <nav id="sidebar">
        <div className="sidebar-header">
          <Image src={Logo} responsive />
        </div>

        <ul className="list-side-menu list-unstyled components">

          <If test={JSON.parse(localStorage.getItem("USER")) && JSON.parse(localStorage.getItem("USER")).role == "professor"}>

            <li className={`${this.state.activeMenu === 'feed' ? 'active-sub-menu' : ''}`} onClick={() => this.actionMenu("feed", true)}>
              <div className="main-menu">
                <h4>Feed</h4>
                <h6>Comunicação, notícias...</h6>
              </div>
              <If test={this.state.activeMenu === 'feed'}>
                <ul className="sub-side-menu list-unstyled">
                  <li onClick={() => this.handleActionMenu("feed/publications")}>
                    <p className={`${this.state.sub_activeMenu == "feed/publications" ? 'active-sub-sub-menu' : ''}`}><Glyphicon glyph="list" /><span className="sub-menu-label">Lista de publicações</span></p>
                  </li>
                </ul>
              </If>

            </li>

            <li className={`${this.state.activeMenu === 'alunos' ? 'active-sub-menu' : ''}`} onClick={() => this.actionMenu("alunos", true)}>
              <div className="main-menu">
                <h4>Alunos</h4>
                <h6>Listagem de alunos, informações detalhadas, atualização de status...</h6>
              </div>
              <If test={this.state.activeMenu === 'alunos'}>
                <ul className="sub-side-menu list-unstyled">
                  <li onClick={() => this.handleActionMenu("alunos")}>
                    <p className={`${this.state.sub_activeMenu == "alunos" ? 'active-sub-sub-menu' : ''}`}><Glyphicon glyph="list" /><span className="sub-menu-label">Lista de alunos</span></p>
                  </li>
                </ul>
              </If>

            </li>

            <li className={`${this.state.activeMenu === 'treino' ? 'active-sub-menu' : ''}`} onClick={() => this.actionMenu("treino", true)}>
              <div className="main-menu">
                <h4>Treino</h4>
                <h6>Montagem de treinos</h6>
              </div>

              <If test={this.state.activeMenu === 'treino'}>
                <ul className="sub-side-menu list-unstyled">
                  <li onClick={() => this.handleActionMenu("treino/exercisesList")}>
                    <p className={`${this.state.sub_activeMenu == "treino/exercisesList" ? 'active-sub-sub-menu' : ''}`}><Glyphicon glyph="list" /><span className="sub-menu-label">Lista de exercícios</span></p>
                  </li>
                  <li onClick={() => this.handleActionMenu("treino/trainingsList")}>
                    <p className={`${this.state.sub_activeMenu == "treino/trainingsList" ? 'active-sub-sub-menu' : ''}`}><Glyphicon glyph="list" /><span className="sub-menu-label">Lista de treinos</span></p>
                  </li>
                </ul>
              </If>

            </li>

            <li className={`${this.state.activeMenu === 'contratos' ? 'active-sub-menu' : ''}`} onClick={() => this.actionMenu("contratos", true)}>
              <div className="main-menu">
                <h4>Contratos</h4>
                <h6>Documentos encaminhados aos alunos no momento do cadastro</h6>
              </div>

              <If test={this.state.activeMenu === 'contratos'}>
                <ul className="sub-side-menu list-unstyled">
                  <li onClick={() => this.handleActionMenu("contratos/consult")}>
                    <p className={`${this.state.sub_activeMenu == "contratos/consult" ? 'active-sub-sub-menu' : ''}`}><Glyphicon glyph="open-file" /><span className="sub-menu-label">Consultoria Esportiva</span></p>
                  </li>
                  <li onClick={() => this.handleActionMenu("contratos/personal")}>
                    <p className={`${this.state.sub_activeMenu == "contratos/personal" ? 'active-sub-sub-menu' : ''}`}><Glyphicon glyph="open-file" /><span className="sub-menu-label">Personal Trainer</span></p>
                  </li>
                </ul>
              </If>

            </li>
          </If>

          {/* <li className={`${this.state.activeMenu === 'financeiro' ? 'active-sub-menu' : ''}`} onClick={() => this.actionMenu("financeiro", false)}>
            <div className="main-menu">
              <h4>Financeiro</h4>
              <h6>Gestão de pagamentos dos alunos</h6>
            </div>

          </li> */}
          {/* <li className={`${this.state.activeMenu === 'agenda' ? 'active-sub-menu' : ''}`} onClick={() => this.actionMenu("agenda", true)}>
            <div className="main-menu">
              <h4>Agenda</h4>
              <h6>Calendário disponível, marcação de aulas...</h6>
            </div>
            <If test={this.state.activeMenu === 'agenda'}>
              <ul className="sub-side-menu list-unstyled">


                <li onClick={() => this.handleActionMenu("agenda/configuration")}>
                  <p className={`${this.state.sub_activeMenu == "agenda/configuration" ? 'active-sub-sub-menu' : ''}`}><Glyphicon glyph="time" /><span className="sub-menu-label">Configurar horários</span></p>
                </li>

              </ul>
            </If>


          </li> */}

          {/* <li className={`${this.state.activeMenu === 'payment' ? 'active-sub-menu' : ''}`} onClick={() => this.actionMenu("payment", false)}>
            <div className="main-menu">
              <h4>Pagamento</h4>
              <h6>Realizar pagamentos</h6>
            </div>

          </li> */}

          <li className={`${this.state.activeMenu === 'logout' ? 'active-sub-menu' : ''}`} onClick={() => this.actionMenu("logout", false)}>
            <div className="main-menu">
              <h4>Sair</h4>
              <h6>Desconectar-se do sistema...</h6>
            </div>

          </li>
        </ul>

      </nav>
    );
  }
}

export default SideMenu;



// WEBPACK FOOTER //
// src/components/side-menu.js